import styles from './index.module.scss';
import Image from "next/image";
import Done from "@/app/images/done.svg";

export default function Complete({data, onChange}) {
    return (
        <div className={styles.container}>
            <Image src={Done}  alt="Done"/>
            <h2>Thank you for Choosing Ninjaz</h2>
            <p>Our team will contact you within 1 hours.</p>
        </div>
    )
}